// extracted by mini-css-extract-plugin
export var documentation = "_l5-1";
export var menu = "_l5-0";